import { action } from 'satcheljs';
import { OwaDate } from 'owa-datetime';
import { addDatapointConfig } from 'owa-analytics-actions';
import {
    getTimePanelDndCustomData,
    timePanelDndOptions,
    HoverSwitchTabsCustomData,
} from '../datapoints';
import { PanelView } from 'owa-time-panel-view-stack';

export const setLastEnterCalendarTab = action('setLastEnterCalendarTab', (lastTime: OwaDate) => ({
    lastTime,
}));

export const resetHeaderTabDropViewState = action(
    'resetHeaderTabDropViewState',
    (previousView: PanelView, nextView: PanelView) =>
        addDatapointConfig(
            {
                name: 'timePanelActionSwitchTabsFromEmailHover',
                options: timePanelDndOptions,
                customData: getTimePanelDndCustomData<HoverSwitchTabsCustomData>({
                    previousView: previousView,
                    nextView: nextView,
                }),
            },
            {
                nextView,
            }
        )
);

export const setLastEnterTasksTab = action('setLastEnterTasksTab', (lastTime: OwaDate) => ({
    lastTime,
}));

export const setShowDayDropHint = action('setShowDayDropHint', (shouldShow: boolean) => ({
    shouldShow,
}));

export const setLastEnterUpNext = action('setLastEnterUpNext', (lastTime: OwaDate) => ({
    lastTime,
}));

export const resetCalendarUpNextState = action('resetCalendarUpNextState');

export const setDayViewDropTimeMinuteOffset = action(
    'setDayViewDropTimeMinuteOffset',
    (dayViewDropTimeMinuteOffset: number) => ({
        dayViewDropTimeMinuteOffset,
    })
);
